import script from "./AudioSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioSlider.vue?vue&type=script&setup=true&lang=ts"

import "./AudioSlider.vue?vue&type=style&index=0&id=c71d2cca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c71d2cca"]])

export default __exports__